import { render, staticRenderFns } from "./GetQuestionSelo.vue?vue&type=template&id=b41b7c0a&scoped=true"
import script from "./GetQuestionSelo.vue?vue&type=script&lang=js"
export * from "./GetQuestionSelo.vue?vue&type=script&lang=js"
import style0 from "./GetQuestionSelo.vue?vue&type=style&index=0&id=b41b7c0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41b7c0a",
  null
  
)

export default component.exports